<template>
  <div class="content">
  </div>
</template>
<script>
  import $ from 'jquery';
  import axios from 'axios';
    export default 
    {name: 'Logout',
      data() {
        return {
          
        }
      },
      created() {
        this.logout();
        
      },

      watch: {
        status () {
        console.log('status')
        if (this.status == true) {
          this.$router.push({path: '/admin/LoginHome'})
        } else {
          this.$message.error(this.errorLoginLocal);
        }
      }
      },
      methods: {
        redirect(){
        if (this.$store.getters.status) {
          this.$router.push({path: '/admin/LoginHome'})
        }
      },

        logout() {
          console.warn("logout");
          localStorage.clear();
          location.reload();
        },
    }
  }
</script>
<style>
</style>